import { Space, Tag, Typography } from 'antd';
import type { PlayerInstallSource as Source } from '@/types/installSource';

const { Text } = Typography;

const when = (iso: string) => new Date(iso).toLocaleString();

/** Player page: where the player came from, as AppsFlyer reported it. */
export function PlayerInstallSource({ source }: { source?: Source | null }) {
  if (!source) return <Text type="secondary">Not reported</Text>;

  const paid = source.status === 'non_organic';
  const campaign =
    source.campaign && source.campaignId
      ? `${source.campaign} (${source.campaignId})`
      : source.campaign || source.campaignId;
  const lines = [
    paid && campaign ? `Campaign: ${campaign}` : null,
    paid && source.adset ? `Adset: ${source.adset}` : null,
    paid && source.ad ? `Ad: ${source.ad}` : null,
    paid && source.channel ? `Channel: ${source.channel}` : null,
    source.installTime ? `Installed ${when(source.installTime)}` : null,
    `First received ${when(source.createdAt)}`,
    source.appsflyerId ? `AppsFlyer ID ${source.appsflyerId}` : null,
  ].filter((line): line is string => line !== null);

  return (
    <Space direction="vertical" size={0}>
      <Space size={4} wrap>
        {paid ? (
          <Tag color="blue">{source.mediaSource || '(unknown network)'}</Tag>
        ) : (
          <Tag color="green">Organic</Tag>
        )}
        {source.isReinstall && <Tag color="orange">Reinstall</Tag>}
      </Space>
      {lines.map((line) => (
        <Text key={line} type="secondary" style={{ fontSize: 12 }}>
          {line}
        </Text>
      ))}
    </Space>
  );
}
